import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from './Icons';
export function ForWho() {
  const yesItems = ['Trabajas duro pero el dinero nunca alcanza o se va rápido', 'Sientes ansiedad física cuando piensas en tus finanzas', 'Has probado afirmaciones sin resultados consistentes', 'Tienes creencias heredadas sobre el dinero que te limitan', 'Cobras menos de lo que vale tu trabajo', 'Quieres una solución científica no motivacional'];
  const noItems = ['Buscas resultados sin ningún tipo de práctica diaria', 'No puedes dedicar 10-15 minutos diarios durante 21 días', 'Crees que el éxito financiero depende solo de estrategias externas', 'Ya tienes una relación completamente sana con el dinero'];
  return <section className="bg-secondary py-10 md:py-16 px-4 md:px-12" data-id="element-67">
      <div className="max-w-5xl mx-auto" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-16" data-id="element-69">
          <h2 className="font-playfair font-bold text-3xl md:text-5xl text-warm-white" data-id="element-70">
            ¿Es el Protocolo RNS para ti?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-71">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-card border-t-4 border-gold rounded-b-xl p-6 md:p-8 shadow-lg text-center" data-id="element-72">
            <h3 className="font-inter font-bold text-gold text-lg md:text-xl tracking-wider mb-6 md:mb-8 flex items-center justify-center gap-2" data-id="element-73">
              <CheckIcon className="w-6 h-6" data-id="element-74" /> SÍ ES PARA TI
            </h3>
            <ul className="space-y-5 md:space-y-6" data-id="element-75">
              {yesItems.map((item, idx) => <li key={idx} className="flex items-start gap-3 md:gap-4 text-left" data-id="element-76">
                  <CheckIcon className="w-5 h-5 md:w-6 md:h-6 text-gold flex-shrink-0 mt-0.5" data-id="element-77" />
                  <span className="font-inter text-sm md:text-base text-warm-white leading-relaxed" data-id="element-78">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-primary border-t-4 border-warm-disabled rounded-b-xl p-6 md:p-8 shadow-lg text-center" data-id="element-79">
            <h3 className="font-inter font-bold text-warm-disabled text-lg md:text-xl tracking-wider mb-6 md:mb-8 flex items-center justify-center gap-2" data-id="element-80">
              <XIcon className="w-6 h-6" data-id="element-81" /> NO ES PARA TI
            </h3>
            <ul className="space-y-5 md:space-y-6" data-id="element-82">
              {noItems.map((item, idx) => <li key={idx} className="flex items-start gap-3 md:gap-4 text-left" data-id="element-83">
                  <XIcon className="w-5 h-5 md:w-6 md:h-6 text-warm-disabled flex-shrink-0 mt-0.5" data-id="element-84" />
                  <span className="font-inter text-sm md:text-base text-warm-muted leading-relaxed" data-id="element-85">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}